<div class="smooth-scrolling without-sub-header">
    <!-- faq detail start -->

    <section class="faq-detail p-80">
        <div class="mx-1485">
            <div class="row">
                <div class="col-12">
                    <div class="faq-content">
                        <div class="accordion" id="accordionPanelsStayOpenExample">
                            <div id="acc-1" class="accordion-item" (click)="toggleAcc(1)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseOne">
                                        How will I know my order has
                                        been successfully placed?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingTwo">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Once you've placed an order, you'll receive a
                                                    confirmation email and sms containing your order
                                                    number and a summary of your purchase. This confirms
                                                    that the order has been successfully placed and is being
                                                    processed.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-2" class="accordion-item" (click)="toggleAcc(2)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseTwo">
                                        Can I modify my order once it has been placed?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingTwo">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Unfortunately, we're unable to modify orders after they
                                                    have been finalized. If you need to make changes,
                                                    please contact our customer service team immediately
                                                    for assistance on potential options.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-3" class="accordion-item" (click)="toggleAcc(3)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseThree">
                                        How can I track my order?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingThree">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Once your order has shipped, you'll receive an email
                                                    and sms containing tracking information, including the
                                                    carrier and tracking number. You can follow the link in
                                                    the email to check the status of your delivery.</li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-4" class="accordion-item" (click)="toggleAcc(4)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingfour">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapsefour" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapsefour">
                                        What is the estimated delivery time?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapsefour" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingfour">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Standard shipping usually takes 5-7 business days.
                                                    Please refer to our shipping policy for more details.</li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-5" class="accordion-item" (click)="toggleAcc(5)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingfive">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapsefive" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapsefive">
                                        Can I cancel my order?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapsefive" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingfive">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>You have the option to cancel your order before it gets
                                                    shipped. Once shipped, you can refuse the delivery and
                                                    your refund will be processed.</li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-6" class="accordion-item" (click)="toggleAcc(6)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingsix">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseSix">
                                        Can I add items to an existing order?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingsix">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Once an order is finalized, items can't be added. A
                                                    separate new order would have to be made for
                                                    additional items.</li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-7" class="accordion-item" (click)="toggleAcc(7)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingseven">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseseven" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseseven">
                                        What is the return policy?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseseven" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingseven">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Refer to our return policy.</li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-8" class="accordion-item" (click)="toggleAcc(8)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingeight">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseEight" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseEight">
                                        How long does it take to process a refund?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseEight" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingeight">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Once we've received your returned items and they've
                                                    passed inspection, your refund will be processed within
                                                    7-10 business days. A confirmation email will be sent
                                                    when the refund is initiated. Refer to our return policy for
                                                    more details.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-9" class="accordion-item" (click)="toggleAcc(9)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingnine">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapsenine" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapsenine">
                                        How do I cancel an order? (before it has been shipped)
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapsenine" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingnine">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Follow these steps to cancel your order.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-10" class="accordion-item" (click)="toggleAcc(10)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingten">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseten" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseten">
                                        How do I cancel an order? (once
                                        it has been shipped)
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseten" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingten">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>If you want to cancel your order then do not accept the
                                                    package at the time of the delivery. It will automatically
                                                    get canceled and your refund will be processed to the
                                                    original mode of payment.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-11" class="accordion-item" (click)="toggleAcc(11)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingeleven">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseeleven" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseeleven">
                                        Are there any cancellation
                                        charges?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseeleven" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingeleven">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>No, there are no cancellation charges.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-12" class="accordion-item" (click)="toggleAcc(12)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingtwelve">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapsetwelve" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapsetwelve">
                                        Will shipping charges be refunded if I cancel ?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapsetwelve" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingtwelve">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Yes, whatever you paid will be refunded back to you.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="acc-13" class="accordion-item" (click)="toggleAcc(13)">
                                <h2 class="accordion-header" id="panelsStayOpen-headingthirteen">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseThirteen" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseThirteen">
                                        How can I make an account on FOY?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThirteen" class="accordion-collapse collapse"
                                    aria-labelledby="panelsStayOpen-headingthirteen">
                                    <div class="accordion-body">
                                        <div class="faq-content">
                                            <ul>
                                                <li>Go to the profile section on the website. Click on
                                                    Login and fill in the details to make an account on
                                                    FOY.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- faq detail end -->
</div>
<!-- Footer START -->
<app-footer-bg></app-footer-bg>
<!-- Footer END -->